export enum Columns {
  Selection = 'selection',
  Actions = 'actions',
  Customers = 'customers',
  Subscription = 'subscription',
  Usage = 'usage',
  Id = 'id',
  ValidUntil = 'validUntil',
}
